/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-return-assign */
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Loader from '../../Component/Common/Loader';
import TenantService from '../../Service/TenantService';
import { toastError, toastForTenant } from '../../SweetAlertUtil/util';
import PageHeader from '../Common/PageHeader';
import Table from '../Common/Table';
import { hot } from 'react-hot-loader';

const DOMAIN_NAME = window.AppConfig.LTA_DOMAIN_NAME;
class Tenants extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_isLoading: false
		};
	}

	setAllTenants = async queryUrl => {
		return TenantService.getAllTenants(queryUrl);
	};

	deactivateUser = async id => {
		try {
			this.setState({ _isLoading: true });
			const response = await TenantService.delete(id);
			this.setState({ _isLoading: false });
			if (response.status) {
				toastForTenant('You have successfully deactivated the Tenant');
			} else {
				toastError('Something Went Wrong');
			}
		} catch (err) {
			this.setState({ _isLoading: false });
			console.log(err);
		}
	};

	render() {
		// NOSONAR

		const columns = [
			{
				name: 'id',
				label: 'id',
				options: {
					filter: true,
					sort: true,
					display: false
				}
			},
			{
				name: 'is_default',
				label: 'Deafult',
				options: {
					display: 'excluded'
				}
			},
			{
				name: 'full_name',
				label: 'Full Name',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (value, tableMeta) => {
						const tenantId = tableMeta.rowData[0];
						return <Link to={`/admin/tenant/${tenantId}`}>{value}</Link>;
					}
				}
			},
			{
				name: 'short_name',
				label: 'Short Name',
				options: {
					display: false,
					filter: true,
					sort: true
				}
			},
			{
				name: 'short_name',
				label: 'Tenant URL',
				options: {
					display: false,
					filter: false,
					sort: false,
					customBodyRender: value => {
						return (
							<a href={`https://${value}.${DOMAIN_NAME}`} rel="noopener noreferrer" target="_blank">
								{`${value}.${DOMAIN_NAME}`}
							</a>
						);
					}
				}
			},
			{
				name: 'min_interest_percentage',
				label: 'Min Interest',
				options: {
					filter: true,
					sort: false,
					customBodyRender: value => {
						return <span className="bold-important">{value}</span>;
					}
				}
			},
			{
				name: 'max_interest_percentage',
				label: 'Max Interest',
				options: {
					filter: true,
					sort: true,
					customBodyRender: value => {
						return <span className="bold-important">{value}</span>;
					}
				}
			},
			{
				name: 'default_time_zone',
				label: 'Default Time Zone',
				options: {
					display: false,
					filter: true,
					sort: true
				}
			},

			{
				name: 'default_language',
				label: 'Default Language',
				options: {
					display: false,
					filter: true,
					sort: true
				}
			},
			{
				name: 'max_amount',
				label: 'Max Amount',
				options: {
					filter: true,
					sort: true,
					customBodyRender: value => {
						return <span className="bold-important">{value}</span>;
					}
				}
			},
			{
				name: 'min_amount',
				label: 'Min Amount',
				options: {
					filter: true,
					sort: true,
					customBodyRender: value => {
						return <span className="bold-important">{value}</span>;
					}
				}
			},
			{
				name: 'is_active',
				label: 'Edit Metadata',
				options: {
					sort: false,
					customBodyRender: (value, obj) => {
						if (value !== undefined) {
							if (value === true) {
								return (
									<Link to={`/admin/tenant/edit/${obj.rowData[0]}`}>
										<button
											className="btn btn-block btn-outline-primary btn-xs"
											// onClick={() => { this.deactivateUser(obj.rowData[0]); }}
											type="button">
											Edit
										</button>
									</Link>
								);
							}
						}
					}
				}
			},
			{
				name: 'is_active',
				label: 'Templates',
				options: {
					sort: false,
					customBodyRender: (value, obj) => {
						if (value !== undefined) {
							return (
								<>
									<Link to={`/admin/tenant/email-templates/${obj.rowData[0]}`}>
										<button className="btn btn-block btn-outline-primary btn-xs" type="button">
											Emails
										</button>
									</Link>
									<br />
									<Link to={`/admin/tenant/sms-templates/${obj.rowData[0]}`}>
										<button className="btn btn-block btn-outline-primary btn-xs" type="button">
											Sms
										</button>
									</Link>
								</>
							);
						}
					}
				}
			},
			{
				options: {
					sort: false,
					customBodyRender: (_value, obj) => {
						return (
							<Link to={`/admin/tenant/deployments/${obj.rowData[0]}`}>
								<button
									className="btn btn-block btn-outline-primary btn-xs"
									// onClick={() => { }}
									type="button">
									View
								</button>
							</Link>
						);
					}
				},
				name: '',
				label: 'Deployments'
			},
			{
				name: '',
				label: 'Forms',
				options: {
					sort: false,
					customBodyRender: (_value, obj) => {
						return (
							<Link to={`/admin/tenant/forms/${obj.rowData[0]}`}>
								<button
									className="btn btn-block btn-outline-primary btn-xs"
									// onClick={() => { }}
									type="button">
									View
								</button>
							</Link>
						);
					}
				}
			},
			{
				name: '',
				options: {
					sort: false,
					customBodyRender: (_value, obj) => {
						return (
							<Link to={`/admin/tenant/states/${obj.rowData[0]}`}>
								<button className="btn btn-block btn-outline-primary btn-xs" type="button">
									View
								</button>
							</Link>
						);
					}
				},
				label: 'Region/interest'
			},
			{
				name: 'is_active',
				label: 'Status',
				options: {
					sort: false,
					customBodyRender: (value, obj) => {
						if (value !== undefined) {
							if (value === true) {
								if (obj.rowData[1] === true) {
									return 'Default Tenant';
								}
								return (
									<button
										className="btn btn-block btn-outline-danger btn-xs"
										onClick={() => {
											this.deactivateUser(obj.rowData[0]);
										}}
										type="button">
										Deactivate
									</button>
								);
							} else {
								return 'Deactivated';
							}
						}
					}
				}
			}
		];

		return (
			<>
				<PageHeader text="Tenants">
					<div className="col-sm-6">
						<span style={{ marginLeft: '70%' }}>
							{' '}
							<Link to="/admin/tenant/create">Add Tenant</Link>
						</span>
					</div>
				</PageHeader>
				<Table columns={columns} dataSourceHandler={this.setAllTenants} dataSourceName="tenants" />
				{this.state._isLoading ? <Loader /> : null}
			</>
		);
	}
}

export default withRouter(hot(module)(Tenants));
